import { getCurrencyFormat } from "src/utils/string"
import { times } from "src/shared/helpers/calculator"
import { DesgloseTarifa, ResumenResult } from "../useMotorTarifas.type"

const getVisibleExtras = (desglose: DesgloseTarifa) => {
    const horas_extra = desglose.subtotal_horas_extra > 0 ? [
        {
            label: `${desglose.horas_extra} horas | ${getCurrencyFormat(desglose.tarifa.costo_hora_extra)}`,
            value: getCurrencyFormat(desglose.subtotal_horas_extra)
        }
    ] : []

    const hospedaje_extra = desglose.subtotal_hospedajes_extra > 0 || desglose.hospedajes_extra > 0 ? [
        {
            label: `${desglose.hospedajes_extra} hospedaje | ${getCurrencyFormat(desglose.tarifa.costo_hospedaje_extra)}`,
            value: getCurrencyFormat(desglose.subtotal_hospedajes_extra)
        }
    ] : []

    return [...horas_extra, ...hospedaje_extra]

}

export function getResumenMotelHospedaje(grupos: DesgloseTarifa[]): ResumenResult[] {
    return grupos.map((t) => {
        const hospedaje = t?.hospedaje?.map((h) => {
            return { label: `${t?.tarifa?.duracion_renta || 0} horas - ${getCurrencyFormat(h.costo_hospedaje)}`, value: getCurrencyFormat(h.subtotal_hospedaje) }
        }) || []
        const grupo = t?.tarifa?.grupo_tarifa
        const extras = getVisibleExtras(t)
        return {
            nombre: `${grupo?.nombre || t?.tarifa?.nombre || ""} | ${grupo?.duracion || 1} horas`,
            items: [...hospedaje, ...extras]
        }
    })
}

export function getResumenHotelHospedaje(grupos: DesgloseTarifa[]): ResumenResult[] {
    return grupos.map((t) => {
        const hospedaje = t?.hospedaje?.map((h) => {
            return { label: `${h.rango} | ${getCurrencyFormat(h.costo_hospedaje)}`, value: getCurrencyFormat(h.subtotal_hospedaje) }
        }) || []
        const extras = getVisibleExtras(t)
        const grupo = t?.tarifa?.grupo_tarifa
        
        return {
            nombre: grupo?.nombre || t?.tarifa?.nombre || "",
            items: [...hospedaje, ...extras]
        }
    })
}

export function getResumenPersonasExtra(grupos: DesgloseTarifa[]): ResumenResult[] {
    return grupos.map((t) => {
        const grupo = t?.tarifa?.grupo_tarifa
        let subtotalPersonas = 0

        t?.hospedaje?.forEach((h) => {
            subtotalPersonas += times(
                times(Number(t?.tarifa?.costo_persona_extra || 0), t?.personas_extra),
                h.dias
            )
        })

        const items = [
            {
                label: `${t?.personas_extra} persona x noche | ${getCurrencyFormat(t?.tarifa?.costo_persona_extra || 0)} x pers.`,
                value: getCurrencyFormat(subtotalPersonas)
            }
        ]

        return {
            nombre: grupo?.nombre || t?.tarifa?.nombre || "",
            items
        }
    })
}